<script lang="ts">
  import { default as Cleave } from "cleave.js";
  import { formatISO, format } from "date-fns";
  import { v4 as uuidv4 } from "uuid";

  import Input from "../Input";

  export let disableFuture: boolean = false;
  export let dateInputValue: Date | null = null;
  export let label: string = "Date";
  export let isError: boolean = false;

  type CleaveEvent = {
    target: {
      name: string;
      value: string;
      rawValue: string;
    };
  };
  const cleaveInit = (ref: HTMLInputElement | null) => {
    if (ref === null) {
      return;
    }
    const cleaveInput = new Cleave(ref, {
      date: true,
      datePattern: ["m", "d", "y"],
      delimiter: "/",
      dateMax: disableFuture
        ? formatISO(new Date(), { representation: "date" })
        : undefined,
      onValueChanged: (evt: CleaveEvent) => {
        const formattedValue = evt.target.value;
        if (formattedValue.length == 8) {
          dateInputValue = new Date(formattedValue);
        }
      },
    });
    return cleaveInput;
  };
</script>

<style>
</style>

<div>
  <Input
    {isError}
    {label}
    {cleaveInit}
    value={dateInputValue ? format(dateInputValue, 'MM/dd/yy') : ''}
    placeholder="mm/dd/yy" />
</div>
